/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/local-storage.service';
import { DialogActions } from 'src/app/utils/DialogActionsArchive';
import { formatDate } from 'src/app/utils/formatDate';
import { CaseService } from 'src/services/case.service';
import { DataSharingService } from 'src/services/data-sharing.service';
import { SubjectsService } from 'src/services/subjects.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { TranslatorService } from 'src/services/translator.service';
import { UserService } from 'src/services/user.service';
import { ModalSizeEnum, Subject } from 'src/types';
import { ArchiveSubjectComponent } from './archive-subject/archive-subject.component';
import { SubjectIdentity } from 'src/app/entrance/types';
import { BroadcastChannelService } from 'src/services/broadcast-channel.service';
import { RightsHistoryDialogComponent } from 'src/app/rights-history-dialog/rights-history-dialog.component';

@Component({
   selector: 'app-subject-details',
   templateUrl: './subject-details.component.html',
   styleUrls: ['./subject-details.component.scss'],
})
export class SubjectDetailsComponent implements OnInit {
   showDivider = false;
   minFromDate = new Date();
   loggedIn: any;
   isSubjectHistoryRendered: Boolean = false;
   isMainCenterBelgrade = false;
   isUserDrugostepeni = false;
   editUserDetailsText = '';
   editUsertDetailTextError = '';
   localStorageCenterId: any;
   isAdmin: boolean = false;
   constructor(
      private route: ActivatedRoute,
      private translate: TranslateService,
      private subjectService: SubjectsService,
      private translatorService: TranslatorService,
      public dialog: MatDialog,
      private dataSharingService: DataSharingService,
      private localStorageService: LocalStorageService,
      private router: Router,
      private caseService: CaseService,
      private toastr: ToastrImplService,
      private userService: UserService,
      private broadcast: BroadcastChannelService,
   ) {
      this.getNationalities();
      this.localStorageCenterId = this.localStorageService.get('localStorageCenterId');
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.isMainCenterBelgrade = this.loggedIn?.csrId === '1' ? true : false;
      this.isUserDrugostepeni = this.userService.isUserDrugostepeni();
      this.isAdmin = this.userService.isGlobalAdmin();

      this.route.params.subscribe(params => {
         this.subjectId = params.id;
         if (!this.isMainCenterBelgrade && !this.isUserDrugostepeni && !this.isAdmin) {
            this.getCurrentSubject(this.subjectId, this.loggedIn?.csrId);
         } else {
            if (this.localStorageCenterId !== undefined && this.localStorageCenterId !== 0) {
               this.getCurrentSubject(this.subjectId, this.localStorageCenterId);
            } else {
               this.router.navigate(['/subjects/']);
            }
         }
      });

      this.translate.get('SUBJECT_DETAILS.DOSSIER_CHANGE_TOOLTIP').subscribe((resp: string) => {
         this.editUserDetailsText = resp;
      });

      this.translate.get('SUBJECT_DETAILS.ARHIVED_DOSSIER_CHANGE_TOOLTIP').subscribe((resp: string) => {
         this.editUsertDetailTextError = resp;
      });

      this.broadcast.messageSubjectFamily$.subscribe(message => {
         const res = message;
         if (res !== null && res.type === 'UPDATE' && this.subjectId == res.subjectId && (this.isAdmin ? this.localStorageCenterId : this.loggedIn?.csrId) === res.csrId) {
            this.subject.familyDossier = res.familyDossier;
            this.translate.get('SUBJECTS.FAMILY_DOSSIER.' + res.familyDossier).subscribe((result: string) => {
               this.familyDossier = result;
            });
            this.isSubjectHistoryRendered = false;
         }
      });
   }
   selectTab(tab: any) {
      if (tab.index === 2) {
         this.isSubjectHistoryRendered = true;
      }
   }
   isDossierAssignedToViewer: boolean;
   isArchived: boolean;
   isEditMode = false;
   subjectId: any;
   subject: Subject;
   nationality = [];
   businessAbility: string;
   category = []; // category of person for nationality
   subjectNationality: string;
   subjectCategory: string;
   familyDossier: any;
   familyType: any;
   date = ['', '', ''];
   gender: boolean;
   jmbg: any;
   object: any = {
      subject: '',
      action: '',
   };
   registrationId = null;

   ngOnInit(): void {}

   public patchSubjectAfterEdit(subjectIdentity: SubjectIdentity): void {
      if (typeof subjectIdentity !== 'undefined') {
         // this.subject = subject;
         this.getCurrentSubject(subjectIdentity.subjectId, subjectIdentity.csrId);
         this.toastr.success('SNACKBAR.DATA_CHANGED');
         this.isSubjectHistoryRendered = false;
      }
      this.isEditMode = false;
   }

   getCurrentSubject(subjectId: any, csrId: any) {
      this.subjectService.getCurrentSubject(subjectId, csrId).subscribe(res => {
         this.subject = res;
         if (this.subject.dateOfBirth !== null) {
            this.subject.dateOfBirth = this.subject.dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         }
         this.subject.dateOfModification = this.subject.dateOfModification.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         this.subject.dateOfCreation = this.subject.dateOfCreation.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         this.registrationId = res.registrationId;
         this.subjectNationality = res?.nationality?.title;
         this.subjectCategory = res?.category?.title;

         if (this.subject?.disabledPerson || this.subject?.disabilityType || this.subject?.occupation || this.subject?.employment || this.subject?.education || this.subject?.maritalStatus) {
            this.showDivider = true;
         }

         if (res.familyDossier === 'NONE') {
            res.familyDossier = null;
         } else {
            this.translate.get('SUBJECTS.FAMILY_DOSSIER.' + res.familyDossier).subscribe((result: string) => {
               this.familyDossier = result;
            });
         }

         if (res.familyType === 'NONE') {
            res.familyType = null;
         } else {
            this.translate.get('SUBJECTS.FAMILY_TYPE.' + res.familyType).subscribe((result: string) => {
               this.familyType = result;
            });
         }

         // u bazi pasivno je 2
         this.isArchived = res.status.id === 2;
      });
   }

   formatDate(date: string) {
      const [y, m, d] = date.split('-');

      return [d, m, y].join('.');
   }

   editSubject() {
      this.isEditMode = true;
   }

   getNationalities() {
      this.nationality = this.translatorService.translateNationalities();
      this.translate.onLangChange.subscribe(() => {
         this.nationality = [];
         this.nationality = this.translatorService.translateNationalities();
      });
   }

   openDialog(action: 'archive' | 'unarchive' | 'rightsHistory', obj: any) {
      this.object.subject = obj;
      this.object.action = action;

      if (action === DialogActions.ARCHIVE) {
         this.caseService.checkActiveRightsForArchive(this.subjectId).subscribe(
            res => {
               const errorMessages: { [key: string]: { message: string; title: string } } = {
                  SOCIAL_CASE_1: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_ACTIVE_CASE', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  SOCIAL_CASE_2: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_UNASSIGNED_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  SOCIAL_CASE_3: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_ACTIVE_CPSU_CASE', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  SOCIAL_CASE_4: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_UNASSIGNED_CPSU_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  NSP: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_NSP_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  DPN: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_DPN_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  PNN: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_PNN_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  OZR: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_OZR_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  CASE_ACCOMMODATION: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_ACCOMMODATION_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
               };
               if (res === 'NO_ACTIVE_CASE') {
                  this.openArchiveComponent();
               } else if (errorMessages[res]) {
                  this.toastr.error(errorMessages[res].message, errorMessages[res].title);
               }
            },
            error => {
               this.toastr.error('ERROR_OCCURED');
            },
         );
      } else if (action === DialogActions.UNARCHIVE) {
         this.openArchiveComponent();
      }
   }

   reloadUser() {
      this.isAdmin ? this.getCurrentSubject(this.subjectId, this.localStorageCenterId) : this.getCurrentSubject(this.subjectId, this.loggedIn?.csrId);
      this.isSubjectHistoryRendered = false;
   }

   openArchiveComponent() {
      const dialogRef = this.dialog.open(ArchiveSubjectComponent, {
         panelClass: 'overlay-panel',
         disableClose: true,
         width: ModalSizeEnum.MINI,
         data: this.object,
      });

      dialogRef.afterClosed().subscribe(result => {
         const { event, data } = result;
         if (event === DialogActions.ARCHIVE || event === DialogActions.UNARCHIVE) {
            this.subject.dateOfModification = formatDate(new Date());
            this.isSubjectHistoryRendered = false;
            this.subject.status = data;
            if (event === DialogActions.ARCHIVE) {
               this.isArchived = true;
               this.toastr.success('SNACKBAR.SUBJECT_ARCHIVED');
               this.dataSharingService.subjectStatusChange.next(true);
               this.isSubjectHistoryRendered = true;
            } else {
               this.isArchived = false;
               this.toastr.success('SNACKBAR.SUBJECT_RETURNED_FROM_ARCHIVE');
               this.dataSharingService.subjectStatusChange.next(false);
               this.isSubjectHistoryRendered = true;
            }
         } else if (event !== 'Cancel') {
            this.toastr.error('SNACKBAR.SUBJECT_NOT_ARCHIVED');
         }
      });
   }

   openRightsHistoryComponent() {
      const dataObject = {
         subjectId: this.subjectId,
         csrId: this.loggedIn.csrId,
         type: 'DPN',
         enableAllRights: true,
      };

      const dialogRef = this.dialog.open(RightsHistoryDialogComponent, {
         panelClass: 'overlay-panel',
         disableClose: false,
         width: ModalSizeEnum.EXTRA_LARGE,
         data: dataObject,
      });
   }
}
